import TableOrderInfo from '../../ui/TableOrderInfo';
import { useSelector } from 'react-redux';
import { selectSelectedId } from '../../../features/modal/modalSlice';
import { useGetOrderByIdQuery } from '../../../features/order/orderApiSlice';
import { skipToken } from '@reduxjs/toolkit/query';
import { formatDate, formatTime } from '../../../utils/formatDateAndTime';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import { MdiCross } from '../../../assets/icons/Icons';
import OrderDetailsModalHeader from '../../common/headers/OrderDetailsModalHeader';

export default function OrderDetailsModal() {

    const orderId = useSelector(selectSelectedId);
    const { data: dataOrderDetails, isError: isErrorOrderDetails, isFetching: isFetchDataOrderDetails, isLoading: isLoadingOrderDetails, refetch: refetchOrderDetails } = useGetOrderByIdQuery(orderId ?? skipToken)
    const isBusy = isLoadingOrderDetails || isFetchDataOrderDetails;

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[80%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[60%] lg:w-[35%]'>
                <div className='flex flex-col w-full'>
                    <div className='py-5 space-y-2'>
                        <OrderDetailsModalHeader/>
                        <hr className="h-px bg-gray-200 border-0" />
                        { isBusy ? (
                            <Loading message='Loading'/>
                        ) : isErrorOrderDetails ? (
                            <ErrorMessage message="Something went wrong, please reload the page/" />
                        ) : (
                            <>
                                <div className='flex flex-col items-center justify-center p-1'>
                                    <p className='text-[22px] font-bold'>
                                        {dataOrderDetails?.orderID}
                                    </p>
                                    <p className='text-[12px] md:text-sm font-medium text-gray-700 uppercase'>
                                        {dataOrderDetails?.chapelName}
                                    </p>
                                    <p className='flex text-[12px] md:text-sm font-medium text-gray-700 uppercase'>
                                        <span>
                                            <MdiCross height={17} color='black'/>
                                        </span>
                                        <span>
                                            {`${dataOrderDetails?.deceasedName}`}
                                        </span>
                                    </p>
                                    <p className="text-[12px] md:text-sm font-medium text-gray-700">
                                        {`${formatDate(dataOrderDetails?.createdAt ?? '')} - ${formatTime(dataOrderDetails?.createdAt ?? '')}`}
                                    </p>
                                </div>
                                <hr className="border-t-[2px] border-dotted border-black" />
                                <div className=''>
                                    <p className='text-[12px] md:text-sm'>
                                        {`Guest Name: ${dataOrderDetails?.userName}`}
                                    </p>
                                    <p className='text-[12px] md:text-sm'>
                                        {`Status: ${dataOrderDetails?.orderStatus}`}
                                    </p>
                                </div>
                                <hr className="border-t-[2px] border-dotted border-black" />
                                <div className=''>
                                    <TableOrderInfo 
                                        orderItems={dataOrderDetails?.items ?? []} 
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
